import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

import { protoColors } from '../../theme/tokens';

export const Nav = styled(Box)(() => ({
  display: 'flex',
  gap: '4px',
  flexWrap: 'wrap',
  padding: '6px',
  borderRadius: '12px',
  backgroundColor: protoColors.surfaceSubtle,
  border: `1px solid ${protoColors.border}`,
  marginBottom: '24px',
}));

export const NavItem = styled('button', {
  shouldForwardProp: (prop) => prop !== 'active',
})<{ active: boolean }>(({ active }) => ({
  border: 'none',
  cursor: 'pointer',
  fontFamily: 'inherit',
  fontSize: '14px',
  fontWeight: 600,
  padding: '8px 14px',
  borderRadius: '8px',
  transition: 'all 0.15s ease',
  color: active ? protoColors.surface : protoColors.textMuted,
  backgroundColor: active ? protoColors.purple : 'transparent',
  '&:hover': {
    backgroundColor: active ? protoColors.purple : protoColors.purpleSoft,
    color: active ? protoColors.surface : protoColors.purple,
  },
}));
